
<div class="cssload-loader">
	<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
	<div class="loader__label" *ngIf="label">{{ label }}</div>
</div>
